import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../store";
import { sendResetPasswordEmail, resetPassword } from "../modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    loading: state.authReducer.loading,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      sendResetPasswordEmail,
      resetPassword,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
